


























































































































import {Component, Prop, Vue} from "vue-property-decorator";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import PxTextArea from "@/views/components/input/formFields/PxTextArea.vue";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";

import {projectStore, structureStore, userStore} from "@/store/store";
import SeasonRow from "@/modules/perRoad/views/components/SeasonRow.vue";
import {UnitSystem} from "@/interfaces/units";
import {createStructureValidations} from "@/modules/structure/lib/validations";
import PrLayerEditor from "@/modules/perRoad/views/components/structure/PrLayerEditor.vue";
import {createNewPavementStructureScenario} from "@/modules/structure/lib/createNew";
import StructureLayerEditor from "@/modules/structure/views/StructureLayerEditor.vue";
import InspectorThreeJS from "@/modules/perRoad/views/components/inspection/InspectorThreeJS.vue";
import CriticalLocationDepthInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationDepthInspector.vue";
import {
  convertDeterministicLayersImperial,
  convertDeterministicLayersMetric
} from "@/modules/structure/lib/convertLayers";
import CriticalLocationLayoutInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationLayoutInspector.vue";

Component.registerHooks(["validations"]);

@Component({
  components: {
    CriticalLocationLayoutInspector,
    CriticalLocationDepthInspector,
    InspectorThreeJS,
    StructureLayerEditor,
    PrLayerEditor,
    SeasonRow,
    PxNumberInput,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class PavementStructureTransferFunctions extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;


  /**
   * Fatigue model params
   */
  get fatigueModelOptions() {
    return [
      {text: "Minnesota DOT", value: "mndot"},
      {text: "PerRoad", value: "perroad"},
      {text: "Custom", value: "custom"},
    ];
  }

  setFatigueModel() {
    switch (this.scenario.selectedFatigueModel) {
      case "mndot":
        this.scenario.fatigueParamA = 2.83;
        this.scenario.fatigueParamB = 3.206;
        break;
      case "perroad":
        this.scenario.fatigueParamA = 2.83;
        this.scenario.fatigueParamB = 3.148;
        break;
      case "custom":
        break;
    }
    this.sync();
  }

  yesNoOptions = [
    {value: true, text: "Yes"},
    {value: false, text: "No"},
  ];

  /**
   * Rutting model
   */

  get ruttingModelOptions() {
    return [
      {text: "AI", value: "ai"},
      {text: "Custom", value: "custom"},
    ];
  }

  setRuttingModel() {
    switch (this.scenario.selectedRuttingModel) {
      case "ai":
        this.scenario.ruttingParamA = 1077000000000000000;
        this.scenario.ruttingParamB = 4.4843;
        break;
      case "custom":
        break;
    }
    this.sync();
  }


  /**
   * Usual stuff
   */

  plotKey = 0;

  get scenario() {
    return structureStore.currentScenario;
  }

  get scenarioImperial() {
    return structureStore.currentImperial;
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  get simulatedLayers() {
    this.plotKey += 1;
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      return convertDeterministicLayersImperial(this.scenario.structureLayers);
    } else {
      return convertDeterministicLayersMetric(this.scenario.structureLayers);
    }
  }

  incrementPlotKey() {
    this.plotKey += 1;
  }

  sync() {
    structureStore.setCurrentScenario(this.scenario);
    console.log(this.scenario.loads);
    this.incrementPlotKey();
  }

  save() {
    this.sync();
    structureStore.saveCurrentScenario();
  }

  validations() {
    return createStructureValidations(this.scenarioImperial, this.page);
  }

  mounted() {
  }
}

